import { useQuery } from "@tanstack/react-query";
import { fetchTemplates } from "@/domains/templates/api";
import { toUiItem } from "@/domains/templates/mappers";
import type { UiTemplateItem } from "@/domains/templates/types";
import { useTenant } from "@/domains/tenant/hooks";
import { getKeyOnlyQueryConfig } from "@/shared/lib/key-only-query-config";

const matrixTemplateKeys = {
  list: () => getKeyOnlyQueryConfig(["matrix", "templates", "list"]),
};

// Featured templates only: a matrix inherits a template's whole structure.
export function useMatrixTemplates(enabled: boolean) {
  const { data: tenantData } = useTenant();
  const tenantId = tenantData?.tenant?.tenant_id ?? "";

  return useQuery({
    queryKey: [...matrixTemplateKeys.list().queryKey, tenantId],
    queryFn: async (): Promise<UiTemplateItem[]> => {
      const templates = await fetchTemplates(
        { search: "", showGlobal: true },
        tenantId,
      );
      return templates.map(toUiItem).filter((item) => item.isGlobal);
    },
    enabled: enabled && Boolean(tenantId),
  });
}
